<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :max-width="$vuetify.breakpoint.xsOnly ? undefined : 600"
    persistent
    scrollable
  >
    <v-card>
      <v-toolbar
        dense
        flat
        color="primary"
        dark
      >
        <v-toolbar-title>Customer Signature</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <!-- Note field (show at top on mobile) -->
        <div class="pa-3">
          <v-text-field
            v-model="note"
            label="Add a note (e.g. '$45 received')"
            outlined
            dense
            clearable
          />
        </div>

        <!-- Signature Pad -->
        <div class="signature-container">
          <vue-signature
            ref="sigPad" 
            :sigOption="options"
            :w="'90%'"
            :h="$vuetify.breakpoint.xsOnly ? '60vh' : '200px'"
          />
        </div>

        <div class="text-right pa-2">
          <v-btn small text @click="clear">Clear</v-btn>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueSignature from "vue-signature";

export default {
  name: "SignaturePadDialog",
  components: { VueSignature },
  props: {
    value: Boolean,
    invoice: { type: Object, default: null },
  },
  data: () => ({
    dialog: false,
    note: "",
    options: {
      minWidth: 4,
      penColor: "black",
      backgroundColor: "rgba(255,255,255,0)",
    },
  }),
  watch: {
    value(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    clear() {
      this.$refs.sigPad.clear();
    },
    save() {
      if (!this.invoice) return;

      const dataUrl = this.$refs.sigPad.save();
      if (!dataUrl) {
        this.$swal("Error", "Please provide a signature.", "error");
        return;
      }
      const payload = {
        note: this.note,
        signature: dataUrl,
        signedAt: new Date().toISOString(),
      };
      this.$emit("save-signature", { invoiceId: this.invoice.id, payload });
      this.close();
    },
    close() {
      this.note = "";
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.signature-container {
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
  position: relative;
}
</style>